import * as React from "react";
import { useCallback } from "react";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { conditionsFormRedux } from "../redux/ConditionsFormRedux";
import { ConditionsForm } from "../components/ConditionsForm";
import { ConditionsFormModel } from "../types/ConditionsFormModel";
import { RouteAgreementDetailsStateFragment } from "@/gql/graphql";

interface Props {
  routeAgreement: RouteAgreementDetailsStateFragment;
}

export const ConditionsPanel: React.FC<Props> = ({ routeAgreement }) => {
  const dispatch = useDispatch();
  const conditionsFormModel = useSelector(
    conditionsFormRedux.selectors.getEntity
  );

  const setFields = useCallback(
    (fields: Partial<ConditionsFormModel>) => {
      dispatch(conditionsFormRedux.actions.setEntityFields(fields));
    },
    [dispatch]
  );

  return (
    <>
      <Helmet title="Conditions - Route agreement - FPP" />

      <ConditionsForm
        value={conditionsFormModel}
        setFields={setFields}
        routeAgreement={routeAgreement}
      />
    </>
  );
};
